'use es6';

import PropTypes from 'prop-types';
export default PropTypes.shape({
  byId: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired
});